import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";

export class AuwProductTeaser extends AuwBaseComponent {
  constructor($el) {
    super($el);
  }

  __PageReady() {

    $('.product-teaser__prices input[type="radio"]#yearly').prop('checked',true);

    const self = this;
    const inputs = self.$el.find('.product-teaser__prices input[type="radio"]');

    inputs.on("change", function (){
      const link = self.$el.find('.product-teaser__submit');
      const currentURL = link.prop('href');
      let url = new URL(currentURL);
      url.searchParams.set("tx_auwcheckout_checkout[type]",$(this).val());
      link.attr('href', url.href.replace(window.location.origin, ""));
    });
  }
}

if ($(".product-teaser--bookingtype").length) {
  $.each($(".product-teaser--bookingtype"), function (i, e) {
    new AuwProductTeaser($(e));
  });
}
